export default __webpack_public_path__ + "static/media/logo.4294cae5.png";